module.exports = __webpack_public_path__ + "static/media/home_cinema.afe57b51.svg";